//BIG ISSUE: form doesnt remember what was filled out after it closes
 //BIG ISSUE: solution it becomes a reducer
//reconsider: naming to match that of the backend
import {
    createSlice,
    nanoid,
    createAsyncThunk,
} from '@reduxjs/toolkit';
import pagani from '../../assets/pagani.jpg';

import { client } from '../../api/client';
//alter and pre and post processing(can pull from fe_ctrl)
//we want our own data caching approach... later

const dummyImages = [
    {
        src: pagani,
        width: 1,
        height: 1
    }
];

const initialState = {//move this to a separate value
    status: 'not_loaded',
    error: null,
    myInventory: {
        total: 0,
        liveAuctions: 0,
        totalItemsSold: 0,
        categories: null,
        items: []//inventory is stored here(bring in data normalizer)
    },
    //of_note:dup this and map per photo(i.e. run 'map function via ' )
    carCreatorData: {
        //of_note:details section is dependent upon auction item type or category(havent decided upon terminology)
        //needed: listing fee for third party,  car title like r-title or equivalent
        //needed: percent calculation
        activeSection: null,
        sectionsCompleteStatus: {
            total_complete_1: 0,
            details_status_1: 0,
            article_status_1: 0,
            media_gallery_status_1: 0,
        },
        detailsSection: {
            listing_title_0: '',//state.carCreatorData.detailsSection.listingTitle
            car_make_0: '',
            model_0: '',
            vin_0: '',
            yr_1: 0,
            transmission_0: '',
            engine_0: '',
            mileage_1: 0,
            start_price_1: 0,
            has_reserve_5: false,
            res_disabled_5: true,
            reserve_amt_1: '',
            auction_date_range_2_4: ['', ''],
            start_time_4: '',
            end_time_4: '',
            state_loc_0: '',
            city_loc_0: '',
            audience_0: 'Public',
        },
        articleSection: {
            brief_descript_0: '',
            brief_descript_gallery_2_3: [],
            //or depending on the version it should be urls
            introduction_0: '',
            introduction_gallery_2_3: [],
            power_train_0: '',
            power_train_gallery_2_3: [],
            exterior_0: '',
            exterior_gallery_2_3: [],
            interior_0: '',
            interior_gallery_2_3: [],
            chassis_0: '',
            chassis_gallery_2_3: [],
            docs_0: '',
            docs_gallery_2_3: [],
        },
        mediaGallerySection: {
            //needed: create metadata before upoload
            photos_2_3: [],
            videos_2_3: [],
            embed_videos_2_0: [],
            docs_2_3: []
        }
    },
    refData: {
        //this will be dynamic and require an 'init' call plus some async thunks
        //needed:find way to denote that the 
        car: {
            make_2_0: [],
            model_2_0: [],
            body_styles_2_0: []
        },
        location: {//needed:payload flow
            state: [],
            city: [],
            zip: []
        },
        
    },
    //here is where we need to the props that are filledout in the creation
};


const auctionItemMgmtSlice = createSlice({
    name: 'auctionItemMgmt',
    initialState,
    reducers: {
        testGalleryUpdated(state, action) {
            //const introFiles = action.payload
            console.log("payload")
            console.log(action.payload)
            state.carCreatorData.articleSection.introductionGallery = action.payload.gallery
            console.log("after payload")
            //postsAdapter.updateOne(state, { id, changes: { title, content } })
        },
        //success
        carCreatorTextInfoUpdated(state, action) {
            console.log(Object.keys(state));
            const { parSection, itemVal, section, sectionItem } = action.payload
            console.log("We are here");
            console.log(`parent:\t${parSection}\nvalue:\t${itemVal}\nsection:\t${section}\nsection item:\t${sectionItem}\n`);
            state[parSection][section][sectionItem] = itemVal
        },
        carCreatorArrayUpdate(state, action) {
            console.log('array updated')
            const { parSection, itemVal, section, sectionItem } = action.payload
            state[parSection][section][sectionItem].push(itemVal)
        },
        /*packageMediaUpld(state, action) {
            - message service worker with multiple files and use client.js (opcodes in homeSlice)
        }*/
        //create crud for arrays as vanilla js file
    },
});

export const {
  testGalleryUpdated,
  carCreatorTextInfoUpdated,
  carCreatorArrayUpdate
} = auctionItemMgmtSlice.actions;

export const selectIntroGallery = state => state.auctionItemMgmt.carCreatorData.articleSection.introductionGallery;
export const selectAllTestData = state => state.auctionItemMgmt.testData.items;
export const selectImage = state => state.auctionItemMgmt.carCreatorData.articleSection.brief_descript_gallery_2_3;
//export const selectImage = state => state.auctionItemMgmt.carCreatorData.articleSection


//descript:mechanism for retrieving a property from the state
//later:add currying of data if necessary
export const carCreatorSelectSectionDataB = val => state => {
    const { parSection, section, sectionItem } = val;
    return state.auctionItemMgmt[parSection][section][sectionItem];
};

//descript: run a test api call to start working with dummy data
//upon return dispatch this event
export const fetchTests = createAsyncThunk('auctionItemMgmt/todo', async () => {
    //endpoints are set in the initial call
    //needed:endpoint should be from payload initialization(alright for development)
    const response = await client.get('http://192.168.1.74:8015/todo')

    return response.data
})

export const testPost = createAsyncThunk(
    'auctionItemMgmt/testPost',
    async testPayload => {
        console.log('test post')
        const response = await client.post(
            'http://192.168.1.74:8015/tester',
            testPayload)
        return response.data
})

export const testLogin = createAsyncThunk(
    'auctionItemMgmt/testLogin',
    async testPayload => {
        console.log('firing away')
        const response = await client.post(
            'http://192.168.1.74:8015/token',
            testPayload)
        return response.data
})

export const testUpload = createAsyncThunk(
    'auctionItemMgmt/testUpload',
    async testPayload => {
    //async (testPayload, {getState}) => {
    console.log(testPayload)
    const response = await client.post(
        'http://192.168.1.74:8015/testUpload',
        testPayload
    )

    console.log(response.data)
    return response.data
})

export default auctionItemMgmtSlice.reducer;
